const moment = require('moment')

export const getDaysDifferenceToToday = dateTime => {
    if (!dateTime) {
        return ''
    }
    return moment().diff(moment(dateTime), 'days')
}

export const formatDateTime = (dateTime) => {
    if (!dateTime) {
        return ''
    }
    return moment(dateTime).format('DD.MM.YYYY HH:mm')
}

export const formatDate = (dateTime) => {
    if (!dateTime) {
        return ''
    }
    return moment(dateTime).format('DD.MM.YYYY')
}

// 2018-02-19T12:27:00

export const formatJSONDate = (momentDate) => {
    return momentDate.format('YYYY-MM-DDTHH:mm:ss')
}


export const dateComparator = (property, sortOrder = 1) => (a, b) => {
    a = a[property]
    b = b[property]
    if (!a && !b) {
        return 0
    }
    if (!a && b) {
        return -1 * sortOrder
    }
    if (a && !b) {
        return sortOrder
    }

    return sortOrder * (moment(a).unix() - moment(b).unix())
}



// WEBPACK FOOTER //
// ./src/util/datetime.js